import {
  FETCH_CLIENTS_REQUEST,
  FETCH_CLIENTS_SUCCESS,
  FETCH_CLIENTS_FAILURE,
  FETCH_PAGES_REQUEST,
  FETCH_PAGES_SUCCESS,
  FETCH_PAGES_FAILURE
} from '../actions';

const initialState = {
  clients: [],
  pages: [],
  loading: false,
  error: false
};

const reducer = (state = initialState, action) => {
  switch(action.type){
    case 'FETCH_CLIENTS_REQUEST':
      return {
        ...state,
        loading: true
      };
    case 'FETCH_CLIENTS_SUCCESS':
      return {
        ...state,
        clients: action.clients,
        loading: false
      }
    case 'FETCH_CLIENTS_FAILURE':
      return {
        ...state,
        loading: false,
        error: true
      }
    case 'FETCH_PAGES_REQUEST':
      return {
        ...state,
        loading: true
      };
    case 'FETCH_PAGES_SUCCESS':
      return {
        ...state,
        pages: action.pages,
        loading: false
      }
    case 'FETCH_PAGES_FAILURE':
      return {
        ...state,
        loading: false,
        error: true
      }
    default:
      return state;
  }

}

export default reducer;
